<template>
    <Dialog :visible="showModal" :modal="true" :closable="false" :breakpoints="{
        '1360px': '50vw',
        '1024px': '60vw',
        '960px': '90vw',
        '640px': '91vw',
    }" :style="{ width: '30vw' }">
        <template #header>
            <div class="ms-auto">
            <button v-if="closable" class="p-dialog-header-icon p-dialog-header-close p-link" type="button"
                @click.prevent="close">
                <i class="p-dialog-header-close-icon pi pi-times"></i>
            </button>
        </div>
        </template>
        <div class="body">
            <div class="text-center my-1">
                <i class="pi pi-info-circle m-auto text-primary fs-large"></i>
            </div>
            <div class="text-center mb-3 fw-bold mb-3 mt-3 text-dark">
                {{ title }}
            </div>
            <div v-if="message" class="text-center mb-3 mt- text-dark">
                {{ message }}
            </div>
            <div v-if="actionLabel" class="d-flex justify-content-center mt-4">
                <button class="btn btn-lg btn-primary text-white rounded-5 px-5" type="button" @click.stop="action">
                    {{ actionLabel }}
                </button>
            </div>
        </div>
    </Dialog>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
    showModal: {
        type: Boolean,
    },
    title: {
        type: String,
    },
    message: {
        type: String,
    },
    closable: {
        type: Boolean,
        default: true,
    },
    actionLabel: {
        type: String,
    }
});
const emits = defineEmits(['close', 'action']);
const close = () => {
    emits('close');
}
const action = () => {
    emits('action');
}
</script>

<style lang="scss" scoped>

.fs-large {
    font-size: 40px;
}

</style>
